<template>
  <p v-if="!cartPayload.length" class="p1">{{ emptyMessage }}</p>
  <div class="bundle-items" v-else>
    <h3 class="p1">Items in your Bundle:</h3>
    <ul v-if="cartPayload">
      <li
        v-for="bundleItem in cartPayload"
        :key="bundleItem.variant_id"
        class="bundle-item f aic"
      >
        <div class="bundle-item__image ratio ro-1">
          <div is="vue-image" :src="bundleItem.image" css="fit-contain" spinner-size="sm" :size="200"></div>
        </div>
        <div class="bundle-item__detail">
          <p class="p2">{{ bundleItem.title }} ({{bundleItem.quantity}})</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: [
    'cart-payload',
    'empty-message'
  ]
}
</script>
